

























































































































































import { Component, Mixins } from 'vue-mixin-decorator';
// import { Component, Vue } from 'vue-property-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { Prop, Watch } from 'vue-property-decorator';
import { Measure, Product } from '@/types/work/product';
import { ErrorHandler, FormError } from '@/modules/FormError';
import { GET_CATEGORIES } from '@/store/models/work/enterprise/products/categories';
import { GET_CATEGORIES as GET_TYPES } from '@/store/models/pub/products/categories';
import { Getter } from 'vuex-class';
import { Categories, Category, Hierarchy } from '@/types/work/product_category';
import CategorySelect from '@/components/work/products/CategorySelect.vue';
import { PublicCategories, PublicCategory } from '@/types/public/products/categories';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import { STORE_REQUEST } from '@/store/models/work/enterprise/products/products';
import { GET_MEASURE } from '@/store/models/work/enterprise/products/measures';
@Component({
  components: { CategorySelect }
})
export default class ProductEditDialog extends Mixins<SlotMixin>(SlotMixin) implements FormError {
  @Prop() public show: boolean = false;
  @Prop() private editItem?: Product;
  public item!: Product;
  public $refs!: {
    form: HTMLFormElement
  };

  public changeType:boolean = false;
  public showCategoryDialog:boolean = false;
  public currentCategory?:number = 0;
  public currentCategoryStructure:any[] = [];
  public structured: Array<any> = [];

  public loading:boolean = false;

  @Getter(GET_CATEGORIES) categories!: Array<Category>;
  @Getter(GET_ENTERPRISE) enterprise!: Enterprise;
  @Getter(GET_TYPES) category_types!: Array<PublicCategory>;
  @Getter(GET_MEASURE) measures!: Array<Measure>;

  public getCurrentCategory ():Array<Hierarchy> {
    if (this.item && this.item.category_id) {
      return (new Categories(this.categories).getHierarchy(this.item.category_id));
    }
    return (new Categories(this.categories).getHierarchy(null));
  }

  public getCurrentCategoryType ():Array<Hierarchy> {
    if (this.item && this.item.category_id) {
      return (new PublicCategories(this.category_types).getHierarchy(this.item.type_category_id));
    }
    return (new PublicCategories(this.category_types).getHierarchy(null));
  }

  @Watch('editItem', { deep: true })
  public OnItemChanged (newValue: Product) {
    this.item = { ...newValue };
  }

  public showChangeCategory (type:boolean = false) {
    this.structured = type
      ? (new PublicCategories([...this.category_types])).getStructured() || []
      : (new Categories([...this.categories])).getStructured() || [];
    if (this.item) {
      this.currentCategory = type ? this.item.type_category_id : this.item.category_id;
      this.currentCategoryStructure = type ? this.getCurrentCategoryType() : this.getCurrentCategory();
    }
    this.changeType = type;
    this.showCategoryDialog = true;
  }

  public changeCategory (newVal:number) {
    this.showCategoryDialog = false;
    if (this.item) {
      this.changeType
        ? this.item.type_category_id = newVal
        : this.item.category_id = newVal;
    }
  }

  public errorMessage: string = '';
  @Watch('categories', { deep: true })
  public onCategoriesChanged (newVal:Array<Category>) {
    this.structured = (new Categories([...newVal])).getStructured() || [];
  }
  created () {
    this.structured = (new Categories([...this.categories])).getStructured() || [];
  }

  setErrors (data: any): void {
    this.$refs.form.setErrors(data);
  }
  store () {
    if (this.item) {
      this.loading = true;
      this.$store.dispatch(STORE_REQUEST, { ...this.item }).then((resp:Product) => {
        this.loading = false;
        this.$emit('save');
      }).catch(e => new ErrorHandler(this, e));
    }
  }
}
